import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
// Deep path, not the `modules/aiAgents` barrel (see AIConversations.tsx).
import { isEndpointMissingError } from "modules/aiAgents/helpers/lessons";

import { AiReviewListResponse } from "../../aiReview.types";
import { AI_REVIEW_QUERY_KEY } from "../../constants/enums";
import {
  GetReviewItemsParams,
  requestGetReviewItems
} from "./getReviewItems.request";

// Until the backend serving the page is deployed, the route answers 404:
// preventDefaultNotFound keeps the global handler from alerting, and the page
// shows a quiet notice instead (isUnavailable).
const useGetReviewItems = ({ status, page, take }: GetReviewItemsParams) => {
  const query = useQuery<AiReviewListResponse, ApiServiceError<ApiError>>({
    queryKey: [AI_REVIEW_QUERY_KEY, "list", { status, page, take }],
    queryFn: async () => await requestGetReviewItems({ status, page, take }),
    keepPreviousData: true,
    meta: { preventDefaultNotFound: true }
  });

  return {
    items: query.data?.data ?? [],
    meta: query.data?.meta,
    counts: query.data?.counts,
    sweep: query.data?.sweep,
    isUnavailable: isEndpointMissingError(query.error),
    ...query
  };
};

export default useGetReviewItems;
